import React from "react";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";

const CommonModalForm = ({
  visible,
  title = "Form",
  fields = [],
  onCancel,
  onSubmit,
  submitLabel = "Save",
  cancelLabel = "Cancel",
  values,
  onChange,
  errors = {},
  requiredFields = [], // ← You can pass ['name', 'email'] etc.
  imagePreview = null, // ← For displaying existing images
  disabled = false // ← To disable form during submission
}) => {
  if (!visible) return null;

  const handleFieldChange = (name, value) => {
    onChange({
      ...values,
      [name]: value,
    });
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onCancel}></button>
          </div>

          <div className="modal-body">
            {fields.map((field) => {
              const isRequired = requiredFields.includes(field.name);
              const fieldError = errors[field.name];

              return (
                <div className="mb-2" key={field.name}>
                  {field.label && (
                    <label className="form-label">
                      {field.label} {isRequired && <span className="text-danger">*</span>}
                    </label>
                  )}

                  {field.type === "textarea" ? (
                    <textarea
                      className={`form-control ${fieldError ? 'is-invalid' : ''}`}
                      placeholder={field.placeholder || ''}
                      value={values[field.name] || ""}
                      disabled={disabled}
                      onChange={(e) => handleFieldChange(field.name, e.target.value)}
                      rows={field.rows || 3}
                    />
                  ) : field.type === "date" ? (
                    <input
                      type="date"
                      className={`form-control ${fieldError ? 'is-invalid' : ''}`}
                      placeholder={field.placeholder || ''}
                      value={values[field.name] || ""}
                      disabled={disabled}
                      onChange={(e) => handleFieldChange(field.name, e.target.value)}
                    />
                  ) : field.type === "select" ? (
                    <Select
                      classNamePrefix="select"
                      className={fieldError ? 'is-invalid' : ''}
                      options={field.options || []}
                      isMulti={field.isMulti}
                      placeholder={field.placeholder || `Select ${field.label || field.name}`}
                      value={
                        field.isMulti
                          ? (values[field.name] || []).map((val) =>
                              field.options.find((opt) => opt.value === val)
                            )
                          : field.options.find((opt) => opt.value === values[field.name]) || null
                      }
                      onChange={(selected) =>
                        handleFieldChange(
                          field.name,
                          field.isMulti
                            ? (selected || []).map((s) => s.value)
                            : selected?.value || ""
                        )
                      }
                    />
                  ) : field.type === 'file' ? (
                    <>
                      {(imagePreview && field.name === 'images') || values[field.name] ? (
                        <div className="mb-2">
                          <img
                            src={
                              imagePreview || 
                              (typeof values[field.name] === 'string' 
                                ? values[field.name] 
                                : values[field.name] 
                                  ? URL.createObjectURL(values[field.name])
                                  : '')
                            }
                            alt="Preview"
                            className="img-thumbnail"
                            style={{ maxWidth: '200px', height: 'auto', maxHeight: '150px' }}
                          />
                          <div className="mt-1">
                            <button
                              type="button"
                              className="btn btn-sm btn-danger me-2"
                              onClick={() => {
                                handleFieldChange(field.name, null);
                                if (field.name === 'images') {
                                  // Clear preview by calling onChange with empty values
                                  onChange({ ...values, [field.name]: null });
                                }
                              }}
                            >
                              Remove Image
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-secondary"
                              onClick={() => {
                                // Create a hidden input to trigger file selection
                                const input = document.createElement('input');
                                input.type = 'file';
                                input.accept = field.accept || 'image/*';
                                input.onchange = (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    handleFieldChange(field.name, file);
                                  }
                                };
                                input.click();
                              }}
                            >
                              Change Image
                            </button>
                          </div>
                        </div>
                      ) : (
                        <input
                          type="file"
                          name={field.name}
                          className={`form-control ${fieldError ? 'is-invalid' : ''}`}
                          accept={field.accept || 'image/*'}
                          disabled={disabled}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            handleFieldChange(field.name, file);
                          }}
                        />
                      )}
                    </>
                  ) : field.type === 'checkbox' ? (
                    <div className="form-check mt-2">
                      <input
                        type="checkbox"
                        className={`form-check-input ${fieldError ? 'is-invalid' : ''}`}
                        id={field.name}
                        checked={values[field.name] || false}
                        disabled={disabled}
                        style={{ transform: 'scale(1.2)' }}
                        onChange={(e) => {
                          console.log(`Checkbox ${field.name} changed to:`, e.target.checked);
                          handleFieldChange(field.name, e.target.checked);
                        }}
                      />
                      <label className="form-check-label ms-2" htmlFor={field.name} style={{ userSelect: 'none' }}>
                        {field.placeholder || field.label}
                      </label>
                    </div>
                  ) : (
                    <input 
                       name={field.name}
                      type={field.type || "text"}
                      className={`form-control ${fieldError ? 'is-invalid' : ''}`}
                      placeholder={field.placeholder || ''}
                      value={values[field.name] || ""}
                      disabled={disabled}
                      onChange={(e) => handleFieldChange(field.name, e.target.value)}
                    />
                  )}

                  {fieldError && (
                    <div className="invalid-feedback d-block">{fieldError}</div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onCancel} disabled={disabled}>
              {cancelLabel}
            </button>
            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#C44C23", color: "white", border: "none" }}
              onClick={onSubmit}
              disabled={disabled}
            >
              {submitLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonModalForm;
